import * as Yup from "yup";
import OtrosForm from "./formModel";
import {isValidPhoneNumber} from "react-phone-number-input";

const {
    formField: {
        email,
        telefono,
        apellido,
        nombre,
        codigosLocalidad,
        dni,
        fechaNacimiento,
        montoBruto,
        condicionLaboral
    },
} = OtrosForm;

export default [
    Yup.object().shape({
        [nombre.name]: Yup.string()
            .required(`${nombre.requiredErrorMsg}`)
            .matches(/^[aA-zZ\u00f1\u00d1\s]+$/, "Ingrese un nombre válido")
            .max(40, "El nombre ingresado es muy largo"),
        [apellido.name]: Yup.string()
            .required(`${apellido.requiredErrorMsg}`)
            .matches(/^[aA-zZ\u00f1\u00d1\s]+$/, "Ingrese un apellido válido")
            .max(40, "El apellido ingresado es muy largo"),
        [email.name]: Yup.string()
            .required(`${email.requiredErrorMsg}`)
            .email("Ingrese un email válido"),
        [telefono.name]: Yup.string()
            .test('telefono', "El celular ingresado no es válido",
                (value) => {
                    if (typeof value === "string")
                        return (isValidPhoneNumber(value))
                    else return false
                }
            ),
        [codigosLocalidad.name]: Yup.string().required(`${codigosLocalidad.requiredErrorMsg}`)
            .test('codigoLocalidad', "Seleccione una localidad válida",
                (value) => {
                    if (value) return value.includes(",")
                    else return false
                }),
        [fechaNacimiento.name]: Yup.date()
                .max(new Date(Date.now() - 567648000000), "El cliente debe tener al menos 18 años para contratar")
                .required(`${fechaNacimiento.requiredErrorMsg}`),
        [dni.name]: Yup.number()
            .required(`${dni.requiredErrorMsg}`)
            .min(1000000, "El documento ingresado no es válido")
            .max(99999999, "El documento ingresado no es válido")
            .integer()
            .typeError("Introduzca únicamente números"),
    }),
    Yup.object().shape({
        [montoBruto.name]: Yup.number().when([condicionLaboral.name], {
            is: '0',    // Empleado
            then: Yup.number()
                .required(`${montoBruto.requiredErrorMsg}`)
                .integer()
                .typeError("Introduzca únicamente números")
                .min(1, 'El monto no puede ser inferior o igual a cero')
                .max(2000000, 'El monto no uede ser superior a $2.000.000'),
        })
    })
];